import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlType, SearchControl } from 'bpt-ui-library/bpt-search';
import { TrainingItemConstants } from '../../training-item/constants/training-item-constants';
import { Observable, of } from 'rxjs';
import { TrainingItemGroupService } from '../../training-item/services/training-item-group.service';
import { TrainingItemGroupSearch } from '../models/training-item-group-search';
import { TrainingItemGroupSearchCriteria } from '../models/training-item-group-search-criteria';
import { SearchResult } from '../../shared/models/search-result';
import { TrainingItemGroupSearchResult } from '../models/training-item-group-search-result';
import { TrainingItemGroupPanelListComponent } from '../training-item-group-panel-list/training-item-group-panel-list.component';


@Component({
  selector: 'app-training-item-group-search',
  templateUrl: './training-item-group-search.component.html',
  styleUrls: ['./training-item-group-search.component.scss']
})
export class TrainingItemGroupSearchComponent implements OnInit{
  @Input() feature!:string;
  searchControl: SearchControl[] = [];
  scopeList: any = [];
  isScopeLookup:boolean = false;
  placeHolder: string = TrainingItemConstants.Training_Item_Group_Search_Placeholder;
  errorText: string = '';
  trainingItemGroupSearchData!: TrainingItemGroupSearch;
  trainingItemGroups!:TrainingItemGroupSearchResult[];
  displayDataCollected: any;
  isSearch : boolean = false;
  spinnerOn: boolean = false;
  @Output() shouldAddTrainingItemButtonDisplayed = new EventEmitter();
  @Output() emitSelectedData= new EventEmitter();
  @ViewChild(TrainingItemGroupPanelListComponent)
  private trainingItemGroupPanel!:TrainingItemGroupPanelListComponent;


  constructor(private trainingItemGroupService: TrainingItemGroupService){
    
  }
  
  ngOnInit(): void {
    this.initialize();
  }

  initialize() {
    this.trainingItemGroupService.geteQMSScopesForTrainingItemGroupSearch(this.feature).subscribe((eQMSScopeLookup)=>{
      for (let dataItem of eQMSScopeLookup) {
        this.scopeList.push({
          value:dataItem.eQMSScopeId,
          name:dataItem.eQMSScopeName
        })
      }
      this.searchControl.push({
        controlType: ControlType.List,
        label: 'eQMS Scope',
        fieldName: 'eQMSScope',
        multiSelect: true,
        options: this.scopeList,
        value: undefined,
        labelField: 'name',
        valueField: 'value',
        showFilter:true,
        order: 1,
      });
    });
    this.isScopeLookup = true;
  }

  getSearchResults = (searchText:string): Observable<number> => {
    this.spinnerOn = true;
    let totalRecordCount = 0;
    let searchCriteria : TrainingItemGroupSearchCriteria = new TrainingItemGroupSearchCriteria();
    if(this.trainingItemGroupSearchData !== null && this.trainingItemGroupSearchData !== undefined){
      searchCriteria.eQMSScopes = this.trainingItemGroupSearchData.eQMSScopes;
    }
    if(searchText!==null && searchText!=undefined) searchCriteria.searchText = searchText;
    this.trainingItemGroupService.searchTrainingItemGroups(searchCriteria).subscribe((searchResults:SearchResult)=>{
      this.trainingItemGroups = searchResults.records;
      this.spinnerOn = false;
      totalRecordCount = searchResults.totalRecordCount;
      this.setButtonOnSearchRecordCount(totalRecordCount);
    });
    this.isSearch = true;
    return of(totalRecordCount);
  }

  getAdvancedSearchResults= (filters: Array<any>, searchText:string): Observable<number> => {
    this.spinnerOn = true;
    let totalRecordCount = 0;
    let searchCriteria: TrainingItemGroupSearchCriteria = {};
    if(searchText!==null && searchText!=undefined) searchCriteria.searchText = searchText;
    filters.forEach(filterControl=>{ 
      switch (filterControl.columnName) {
        case "eQMSScope":
          searchCriteria.eQMSScopes=filterControl.values
          break;
      }
    })
    this.trainingItemGroupService.searchTrainingItemGroups(searchCriteria).subscribe((searchResults:SearchResult)=>{
      this.trainingItemGroups = searchResults.records;
      this.spinnerOn = false;
      totalRecordCount = searchResults.totalRecordCount;
      this.setButtonOnSearchRecordCount(totalRecordCount);
    });
    this.isSearch = true;
    return of(totalRecordCount);
  }

  linkedItemsSelectedData(event:any){
    this.displayDataCollected=event;
    this.emitSelectedData.emit(this.displayDataCollected);  
  }

  getLinkedItemsSelection(){
    this.trainingItemGroupPanel.clearSelection();
  }

  setButtonOnSearchRecordCount(searchRecordsCount:number){
      this.shouldAddTrainingItemButtonDisplayed.emit(searchRecordsCount > 0);
  }
}
